<template>
  <div class="pay-record" v-title data-title="业主钱包">
    <!-- <header>
      <img src="../../assets/images/pay-img/pay-record-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        我的账户
      </p>
    </header> -->
    <section>
      <!-- tab -->
      <!-- <van-tabs v-model="active"
        sticky
        swipeable
        line-width="1.5rem"
        line-height="0.03rem"
        color="#F37D0F"
        title-inactive-color="#333333"
        title-active-color="#333333"
        @click="tabBtn"
      > -->
      <!-- 充值记录 -->
        <!-- <van-tab title="我的现金">
          <div class="pay-rank">
            <div class="record_msg" v-for="(item,index) in recharge_record_list" :key="index">
              <p class="img">
                <img src="../../assets/images/pay-img/pay-record-img/money.png" alt="">
              </p>
              <div class="msg">
                <p>
                  充值
                </p>
                <p>
                  {{item.create_time}}
                </p>
              </div>
              <div class="moneyNum">
                +{{item.money}}
              </div>
            </div>
          </div>
        </van-tab> -->
        <!-- 积分记录 -->
        <!-- <van-tab title="我的积分">
          <div class="pay-rank">
            <div class="record_msg" v-for="(item,index) in score_list" :key="index">
              <p class="img">
                <img src="../../assets/images/pay-img/pay-record-img/jifen.png" alt="">
              </p>
              <div class="msg">
                <p>
                  积分
                </p>
                <p>
                  分享 
                  会员卡 <span>{{item.create_time}}</span>  
                </p>
              </div>
              <div class="moneyNum">
                +{{item.score}}
              </div>
            </div>
          </div>
        </van-tab> -->
        <!-- <van-tab title="房东 提现">
        </van-tab>
      </van-tabs> -->
      <landlord :list="earnings_list"></landlord>
    </section>
  </div>
</template>
<script>

import landlord from '../../components/landlord/landlord'
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);

export default {
  data() {
    return {
      active : 0,
      recharge_record_list: [] , // 充值记录
      score_list: [] , // 积分记录
      earnings_list: [], // 收益列表
    };
  },
  components:{
    landlord
  },
  created(){
    // 充值记录
    this.$axios.get(this.domain.url+"/api/order/index/rechargelog").then((res) => {
      // console.log(res.data.data)
      this.recharge_record_list = res.data.data
    })
    this.active = this.$route.query.active
    // 房东
    this.$axios.get(this.domain.url+'/api/housing/index/landlord').then((res) => {
      // console.log(res)
      this.earnings_list = res.data.data
      // console.log(this.list)
    })
  },
  methods:{
    tabBtn(){
      // 积分
      // this.$axios.get(this.domain.url+"/api/score/index/scorelog").then((res) => {
      //   // console.log(res.data.data)
      //   this.score_list = res.data.data
      // }) 
    },
  }
}
</script>
<style lang="less" scoped>
  .pay-record{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      height: 100%;
      overflow: scroll;
      flex: 1;
      // 充值 积分 记录
      .pay-rank{
        width: 100%;
        .time{
          width: 100%;
          height: .88rem;
          background: #F0F0F0;
          p{
            line-height: .88rem;
            margin-left: .29rem;
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51,51,51,1);
          }
        }
        // 充值 积分 信息
        .record_msg{
          width: 100%;
          height: 1.2rem;
          background: #ffffff;
          border-bottom: .01rem #E4E4E4 solid; 
          .img{
            height: 1.2rem;
            display: flex;
            align-items: center;
            float: left;
            img{
              width: .72rem;
              height: .72rem;
              margin-left: .31rem;
            }
          }
          .msg{
            float: left;
            margin-left: .19rem;
            p{
              &:first-child{
                margin-top: .26rem;
                font-size: 0.32rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: rgba(51,51,51,1);
                line-height: .32rem;
              }
              &:last-child{
                margin-top: .13rem;
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: rgba(153,153,153,1);
                line-height: .24rem;
                
              }
            }
          }
          .moneyNum{
            float: right;
            margin-right: .29rem;
            line-height: 1.2rem;
            font-size:0.36rem;
            font-family: Arial;
            font-weight: 400;
            color: rgba(239,130,1,1);
          }
        }
      }
    }
  }
</style>